<div id="landing-header">
    @if(landingPage === 'index'){
    <header class="header-creative-index bg-primary-900 border-bottom-1 border-primary-50 fixed-top">
        <div class="container-fluid h-100 px-lg-5">
            <div class="row h-100 align-items-center">
                <div class="col-6">
                    <div class="img-container">
                        @if(returnUrl === '/info-creative'){
                        <a [href]="domainUrlCreative" title="SEGO Creative">
                            <img src="assets/images/creative/sego_creative_HN.svg" title="SEGO Creative"
                                alt="SEGO Creative" class="d-none d-lg-block">
                            <img src="assets/images/creative/sego_creative_HN_mobile.svg" title="SEGO Creative"
                                alt="SEGO Creative" class="d-block d-lg-none">
                        </a>
                        }@else {
                        <a routerLink="/creative" title="SEGO Creative">
                            <img src="assets/images/creative/sego_creative_HN.svg" title="SEGO Creative"
                                alt="SEGO Creative" class="d-none d-lg-block">
                            <img src="assets/images/creative/sego_creative_HN_mobile.svg" title="SEGO Creative"
                                alt="SEGO Creative" class="d-block d-lg-none">
                        </a>
                        }
                    </div>
                </div>
                <div class="col-6 text-end">
                    <a routerLink="/creative/registro" [queryParams]="{'returnUrl': returnUrl}"
                        class="btn btn-secondary btn-financiacion" title="Registra tu proyecto">
                        <span class="d-none d-lg-block">{{returnUrl === '/info-creative' ? 'Registra tu proyecto' :
                            'Financia tu proyecto'}}</span>
                        <span class="d-block d-lg-none">Registro</span>
                    </a>
                </div>
            </div>
        </div>
    </header>
    }
    @else if(landingPage === 'registro'){
    <header
        class="header-creative-registro bg-primary-50 border-bottom-6 border-secondary-creative-500 d-flex align-items-center justify-content-center fixed-top">
        @if(returnUrl === '/info-creative'){
        <a [href]="domainUrlCreative" title="SEGO Creative">
            <img src="assets/images/creative/sego_creative.svg" title="SEGO Creative" alt="SEGO Creative"
                class="d-none d-lg-block">
            <img src="assets/images/creative/sego_creative_mobile.svg" title="SEGO Creative" alt="SEGO Creative"
                class="d-block d-lg-none">
        </a>
        }@else {
        <a routerLink="/creative" title="SEGO Creative">
            <img src="assets/images/creative/sego_creative.svg" title="SEGO Creative" alt="SEGO Creative"
                class="d-none d-lg-block">
            <img src="assets/images/creative/sego_creative_mobile.svg" title="SEGO Creative" alt="SEGO Creative"
                class="d-block d-lg-none">
        </a>
        }
    </header>
    }
</div>